import React from 'react';
import * as M from '@mui/material';
import { Container, Scroll, SimpleBox, ModalBox, CloseButton, BorderBox, NoScroll } from './style';
import _ from 'lodash';

export function AxlBox({ noscroll = false, ...props }) {
  return (
    <Container {...props}>
      {noscroll ? (
        <NoScroll height={1}>{props.children}</NoScroll>
      ) : (
        <Scroll>
          <M.Box>{props.children}</M.Box>
        </Scroll>
      )}
    </Container>
  );
}

export function AxlSimpleBox({ bgcolor, children, square = false, ...props }) {
  return children ? (
    <SimpleBox square={square} bgcolor={`${bgcolor || 'primary.grayFourth'}`} {...props}>
      {children}
    </SimpleBox>
  ) : null;
}

export function AxlBorderBox({ children, ...props }) {
  return children ? <BorderBox {...props}>{children}</BorderBox> : null;
}

export const AxlModalBox = React.forwardRef(function AxlModalBox({ bgcolor, onClose, children, closeTheme = 'main', ...props }, ref) {
  return children ? (
    <ModalBox ref={ref} elevation={props.elevation || 3} bgcolor={`${bgcolor || 'primary.white'}`} {...props}>
      {onClose && <CloseButton aria-label="delete" theme={closeTheme} onClick={onClose} />}
      {children}
    </ModalBox>
  ) : null;
});
